import React, { useEffect, useState } from "react";
import LoadingSkeletonScreen from "./skeleton-screen";
import LoadingSpinnerScreen from "./spinner-screen";

const Loading = (props) => {
    const { isVisible, type, ...others } = props;

    if (!isVisible) return null;

    if (type) {
        if (type === "Spinner") {
            return <LoadingSpinnerScreen {...others} />;
        }
    }

    return <LoadingSkeletonScreen />;
};

const LoadingScreen = (props) => {
    const [isVisible, setVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(true);
        }, 300);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="h-full w-full min-h-[300px]">
            <Loading isVisible={isVisible} {...props} />
        </div>
    );
};

export default LoadingScreen;
